import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { SortWrapper } from "./Styled";
import { Sort } from "../../../configs/productOrder";
import { getOrderingValue, SortType } from "../../../configs/sortTypes";
import DropdownMenu from "../DropdownMenu.tsx";

interface FilterMenuProps {
    sortTypes: SortType[];
    fetchItems: Function;
    setCurrentPage: Function;
}

const SortMenu = ({
    sortTypes,
    fetchItems,
    setCurrentPage,
}: FilterMenuProps) => {
    const [menuText, setMenuText] = useState(sortTypes[0].text);
    const location = useLocation();
    const navigate = useNavigate();

    // Initialize menu text from URL parameters
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const ordering = params.get('ordering');
        if (ordering) {
            const sortType = sortTypes.find(type => {
                const expectedOrdering = getOrderingValue(type);
                return expectedOrdering === ordering;
            });
            if (sortType) {
                setMenuText(sortType.text);
            }
        }
    }, [location.search, sortTypes]);

    const handleOnclickItem = (item: SortType) => {
        setMenuText(item.text);
        const sortParams = {
            ordering: getOrderingValue(item),
            page: 1,
        };
        fetchItems(sortParams);
        setCurrentPage(1);
        
        // Update URL with sort parameter
        const params = new URLSearchParams(location.search);
        
        // Preserve the current tab parameter
        const currentTab = params.get('tab');
        
        params.set('ordering', sortParams.ordering);
        params.set('page', '1'); // Reset to page 1
        
        // Ensure tab parameter is preserved
        if (currentTab) {
            params.set('tab', currentTab);
        }
        
        const newURL = `${location.pathname}?${params.toString()}`;
        navigate(newURL, { replace: true });
    };

    return (
        <SortWrapper data-testid="sort-dropdown">
            <DropdownMenu
                menuList={sortTypes}
                menuText={menuText}
                handleOnclickItem={handleOnclickItem}
            />
        </SortWrapper>
    );
};

export default SortMenu;
